<template>
  <div>
    <b-row>
      <b-col sm="6">
        <b-form-group label="Parceiro">
          <input-select
            v-model="model.parceiro"
            :options="parceiros"
            single
            :disabled="pesquisaChave || pesquisaEmv || pesquisaDocumento"
          />
        </b-form-group>
      </b-col>

      <b-col sm="4">
        <b-form-group label="Agência">
          <input-select
            v-model="model.agencia"
            @input="changeAgencia"
            :options="agencias"
            placeholder="Todas"
            single
            :disabled="
              !model.parceiro ||
              pesquisaChave ||
              pesquisaEmv ||
              pesquisaDocumento
            "
          />
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group label="Conta">
          <input-select
            v-model="model.contaCombo"
            :search="pesquisaConta"
            :options="contas"
            placeholder="Todas"
            single
            :disabled="
              !model.agencia ||
              pesquisaChave ||
              pesquisaEmv ||
              pesquisaDocumento
            "
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="3">
        <b-form-group label="Tipo QRCode Dinâmico">
          <input-select
            v-model="model.tipoQRCodeDinamico"
            :options="tipoQRCodeDinamico"
            single
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Código EMV">
          <b-input
            v-model="model.emv"
            :disabled="pesquisaChave || pesquisaDocumento"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="6">
        <b-form-group label="Chave PIX">
          <b-input
            v-model="model.chavePix"
            :disabled="pesquisaEmv || pesquisaDocumento"
          />
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group label="Documento Federal Pagador">
          <b-input
            v-model="model.documentoPagador"
            type="text"
            v-mask="documentMask"
            :disabled="pesquisaChave || pesquisaEmv"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="3">
        <b-form-group label="Data Registro">
          <input-date
            v-model="model.dtRegistro"
            :max="dtMax"
            v-mask="'##/##/####'"
            :format="'dd/MM/yyyy'"
            :disabled="
              pesquisaChave ||
              pesquisaEmv ||
              pesquisaDocumento ||
              !model.parceiro
            "
          >
          </input-date>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group label="Data Vencimento">
          <input-date
            v-model="model.dtVencimento"
            :min="dtMin"
            v-mask="'##/##/####'"
            :format="'dd/MM/yyyy'"
            :disabled="
              pesquisaChave ||
              pesquisaEmv ||
              pesquisaDocumento ||
              !model.parceiro
            "
          >
          </input-date>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group label="Situação">
          <input-select
            v-model="model.situacaoQRCode"
            :options="situacaoQRCode"
            :disabled="pesquisaChave || pesquisaEmv || pesquisaDocumento"
            single
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getDocumentMask } from '@/helpers/masks'

export default {
  props: {
    parceiroSelected: { type: Boolean, default: false },
    value: { type: Object }
  },
  data() {
    return {
      parceiros: [],
      agencias: [],
      contas: [],
      modelCorrentista: {},
      situacaoQRCode: this.$api.Arrays.SituacaoQRCode,
      tipoQRCodeDinamico: this.$api.Arrays.TipoQRCodeDinamico
    }
  },
  computed: {
    documentMask () {
          const v = this.model.documentoPagador || null
          return getDocumentMask(v)
    },
    model: {
      get() {
        var obj = this.value
        return obj
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    dtMin: function () {
      return this.model.datInicio
        ? kendo.parseDate(this.model.dtInicio)
        : new Date('1970-01-01Z00:00:00:000')
    },
    dtMax: function () {
      return this.model.dtFim ? kendo.parseDate(this.model.dtFim) : new Date()
    },
    resetDate: function () {
      if (this.model.parceiro.value == 0) {
        this.model.dtRegistro = null
        this.model.dtVencimento = null
      }
    },
    pesquisaChave: {
      get() {
        this.$set(this.model, 'parceiro', 0)
        return this.model.chavePix ? this.model.chavePix !== '' : false
      },
      set(value) {
        if (value) {
          this.model = {
            situacaoQRCode: this.situacaoQRCode.find(x => x.value == null)
          }
        }
      }
    },
    pesquisaEmv: {
      get() {
        this.$set(this.model, 'parceiro', 0)
        return this.model.emv ? this.model.emv !== '' : false
      },
      set(value) {
        if (value) {
          this.model = {
            situacaoQRCode: this.situacaoQRCode.find(x => x.value == null)
          }
        }
      }
    },
    pesquisaDocumento: {
      get() {
        this.$set(this.model, 'parceiro', 0)
        return this.model.documentoPagador
          ? this.model.documentoPagador !== ''
          : false
      },
      set(value) {
        if (value) {
          this.model = {
            situacaoQRCode: this.situacaoQRCode.find(x => x.value == null)
          }
        }
      }
    }
  },
  watch: {
    'model.contaCombo': function (val) {
      if (val) {
        this.$set(this.model, 'conta', val.value)
        this.$set(this.model, 'contaText', val.text)
      } else {
        this.$set(this.model, 'conta', null)
        this.$set(this.model, 'contaText', null)
      }
      this.changeConta(val)
    },
    'model.parceiro': function (val) {
      if (val) {
        let parceiroText = this.parceiros.find(x => x.value === val).text
        this.$set(this.model, 'parceiroText', parceiroText)
      } else {
        this.$set(this.model, 'dtRegistro', null)
        this.$set(this.model, 'dtVencimento', null)
        this.$set(this.model, 'parceiroText', null)
      }
      this.loadComboAgencias(val)
    } 
  },
  created() {
    this.pesquisaConta = _.debounce(this.loadComboContas, 300)
    this.model = {
      situacaoQRCode: this.$api.Arrays.SituacaoQRCode.find(s => s.text === 'Todos').value,
      tipoQRCodeDinamico: this.$api.Arrays.TipoQRCodeDinamico.find(s => s.text === 'Todos').value,
    }
  },
  methods: {
    loadComboParceiros() {
      let th = this
      th.$api.Parceiros.GetAll().then(function (response) {
        th.parceiros = []
        th.$set(th.model, 'parceiros', null)
        if (th.$api.UI.PostLoadData(response)) {
          if (!th.parceiros.find(o => o.text === 'Todos' && !!o.value)) {
            th.parceiros.unshift({ value: 0, text: 'Todos' })
            th.$set(th.model, 'parceiro', 0)
          }
          response.forEach(function (item) {
            let parceiro = {
              value: item.codigo,
              text: item.nome.concat(
                '',
                ' (CNPJ: ',
                th.$api.UI.Format.DocumentoFederal(item.documentoFederal),
                ')'
              )
            }
            th.parceiros.push(parceiro)
          })
          if (th.parceiroSelected) {
            th.$set(th.model, 'parceiro', response[0].codigo)
          }
        }
      })
    },
    loadComboAgencias(parceiro) {
      this.model.agencia = null
      this.model.conta = null

      if (!parceiro) return
      let th = this

      let dto = {
        parameters: [
          { name: 'codigoBanco', value: null },
          { name: 'codigoParceiro', value: parceiro }
        ]
      }

      th.$api.Agencias.GetAll(dto).then(function (response) {
        th.agencias = []
        th.$set(th.model, 'agencia', null)
        if (th.$api.UI.PostLoadData(response)) {
          if (!response.length || response.length === 0) {
            th.$api.UI.ShowError(
              'Erro',
              'Não existem agências cadastradas para este banco ou parceiro'
            )
          } else {
            response.forEach(function (item) {
              th.agencias.push({
                value: item.codigo,
                text: item.numero + '-' + item.digito + ' ' + item.nome
              })
            })
            if (
              th.autoSelectAgencia &&
              response[0].numero === '0001' &&
              +response[0].ditito === 8
            ) {
              th.$set(th.model, 'agencia', response[0].codigo)
            }
          }
        }
      })
    },
    changeAgencia() {
      this.$nextTick(function () {
        this.loadComboContas()
      })
    },
    loadComboContas(conta) {
      let th = this
      if (th.model.agencia) {
        if (!conta && th.model.contaCombo) return
        let dto = {
          parameters: [
            { name: 'codigoAgencia', value: th.model.agencia },
            { name: 'codigoParceiro', value: th.model.parceiro },
            { name: 'situacaoConta', value: th.model.contaAtivas },
            { name: 'numeroConta', value: conta }
          ]
        }
        if (!dto) return
        th.$api.Contas.ComboContas(dto).then(function (data) {
          if (data) {
            if (!data.length || data.length === 0) {
              th.$api.UI.ShowError(
                'Erro',
                'Não foram encontradas contas com os parâmetros informados'
              )
            } else {
              let arrayContas = []
              data.forEach(function (item) {
                arrayContas.push({
                  value: item.codigo,
                  text: item.contaPgto
                })
              })

              th.$nextTick(function () {
                th.contas = arrayContas
              })
            }
          }
        })
      } else {
        th.$set(this, 'contas', [])
        th.$set(this.model, 'contaCombo', null)
      }
    },
    changeConta(val) {
      let th = this
      this.modelCorrentista.nome = ''
      this.modelCorrentista.documentoFederal = ''
      this.modelCorrentista.tipoPessoa = null

      if (val && val.value) {
        th.$api.ContaCorrentistas.GetCorrentistaTitular(val.value).then(
          function (response) {
            if (th.$api.UI.PostAction(response, '', false)) {
              th.modelCorrentista.nome = response.nome
              th.modelCorrentista.documentoFederal =
                th.$api.UI.Format.DocumentoFederal(response.documentoFederal)
              th.modelCorrentista.tipoPessoa = response.tipoPessoa
              th.modelCorrentista = Object.assign({}, th.modelCorrentista)
            }
          }
        )
      }
    },
    refresh() {
      this.$emit('refresh')
    }
  },
  mounted: function () {
    this.loadComboParceiros()
  }
}
</script>
